@if (getStrategies() && getStrategies().length) {
  <div class="flex w-[18rem] flex-col" *transloco="let t">
    <div>
      <h5>{{ t("strategies-infos.strategies_ct", { campaignType }) }}</h5>
    </div>
    @if (getStrategies().length) {
      <div class="rounded border p-2">
        @for (_strategy of getStrategies(); track _strategy) {
          <div class="mb-2">
            <app-strategy-link [strategyId]="_strategy.strategyId" />
          </div>
        }
      </div>
    }
  </div>
}
